var map = {
	"./E.svg": "fcf6",
	"./ENE.svg": "a257",
	"./ESE.svg": "8cb5",
	"./N.svg": "298f",
	"./NE.svg": "d889",
	"./NNE.svg": "1c7a",
	"./NNW.svg": "21b6",
	"./NW.svg": "1c7d",
	"./S.svg": "8671",
	"./SE.svg": "774b",
	"./SSE.svg": "242c",
	"./SSW.svg": "f18a",
	"./SW.svg": "04ee",
	"./W.svg": "e783",
	"./WNW.svg": "f45c",
	"./WSW.svg": "93a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e914";